import setTrimLevel from '../cms-content-slices/modules/trim-level';
import setupFinance from './modelIndex/finance';

const trimLevelSpec = document.querySelectorAll('.cms-offer__content-block--trim-level');
if (trimLevelSpec.length > 0) {
    for (let index = 0; index < trimLevelSpec.length; index++) {
        setTrimLevel(trimLevelSpec[index]);
    }
}

setupFinance();